import { NgStyle, NgClass } from '@angular/common';
import { Component, Input, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-truncate-text',
    templateUrl: './truncate-text.component.html',
    styleUrls: ['./truncate-text.component.scss'],
    standalone: true,
    imports: [NgStyle, NgClass]
})
export class TruncateTextComponent implements AfterViewInit, OnChanges {
    @Input() text = '';
    @Input() clampLines = 2;
    @Input() collapsible = false; // allow to hide/show
    @Input() customStyles: { [key: string]: any } = {};
    @Input() customClasses = '';
    @Input() moreText = 'more';
    @Input() lessText = 'less';

    @ViewChild('textBlock') textBlock!: ElementRef;

    expanded = false;
    isOverflowing = false;
    combinedStyles: { [key: string]: any } = {};

    private updateStyles() {
        this.combinedStyles = {
            ...this.customStyles,
            '--clamp-lines': this.clampLines,
            '--more-text': `"...${this.moreText}${'\u00a0'.repeat(20)}"`
        };
    }

    ngAfterViewInit() {
        this.updateStyles();
        this.checkOverflow();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['text']) {
            this.expanded = false;
            setTimeout(() => this.checkOverflow(), 0);
        }
    }

    checkOverflow() {
        if (!this.textBlock?.nativeElement) return;

        const el = this.textBlock.nativeElement;

        // Reset to normal display to measure actual height
        el.style.display = 'block';
        el.style.webkitLineClamp = 'unset';
        el.style.webkitBoxOrient = 'unset';
        el.style.overflow = 'visible';

        const lineHeight = this.getLineHeight(el);
        const maxHeight = lineHeight * this.clampLines;
        const actualHeight = el.offsetHeight;

        this.isOverflowing = actualHeight > maxHeight;
        
        // Reset styles
        el.style.display = '';
        el.style.webkitLineClamp = '';
        el.style.webkitBoxOrient = '';
        el.style.overflow = '';
    }

    private getLineHeight(element: HTMLElement): number {
        const computed = getComputedStyle(element);
        let lineHeight = parseFloat(computed.lineHeight);
        
        if (isNaN(lineHeight)) {
            // Fallback calculation when lineHeight is "normal"
            const fontSize = parseFloat(computed.fontSize);
            lineHeight = fontSize * 1.2; // Default line-height multiplier
        }
        
        return lineHeight;
    }

    toggle() {
        this.expanded = !this.expanded;
    }

    onMoreClick(event: Event) {
        if (!this.expanded) {
            event.preventDefault();
            this.toggle();
        }
    }
}
